
import debounce from 'lodash/debounce'
import 'components/catalog.tag'
import moment from 'moment'
riot.tag2('sales-list', '\n  <virtual hide="{loader}">\n\n\n    <div class="col-md-3 hidden-xs hidden-sm">\n      <catalog-tree object="SalesBrand" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" reload="true" descendants="true" deselall="true"></catalog-tree>\n    </div>\n    <div class="col-md-9 col-xs-12 col-sm-12">\n      <catalog object="Sales" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" before-success="{getAggregation}" store="warehouse-list" disablepagination="true" filters="{allFilters}" combine-filters="true">\n        <yield to="filters">\n          <div class="well well-sm">\n            <div class="form-inline">\n              <div class="form-group">\n                <label class="control-label">От даты</label>\n                <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n              </div>\n              <div class="form-group">\n                <label class="control-label">До даты</label>\n                <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n              </div>\n            </div>\n          </div>\n        </yield>\n        <yield to="head-right">\n          <div class="form-group pull-right">\n            <div>\n              <label class="text-muted pull-left">\n                 Итого стоимость по продаже:<strong> {parent.item.totalAmount}</strong></label>\n            </div>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="pos">{parent.i + 1}</datatable-cell>\n          <datatable-cell name="article" onclick="{handlers.copyText}">{row.article}</datatable-cell>\n          <datatable-cell name="nameBrand" onclick="{handlers.copyText}">{row.nameBrand}</datatable-cell>\n          <datatable-cell name="name" onclick="{handlers.copyText}" style="width: 40%;">{row.name}</datatable-cell>\n          <datatable-cell name="expend">{row.expend}</datatable-cell>\n\n          <datatable-cell name="amount" onclick="{handlers.copyText}" style="max-width: 20px;">{row.amount}</datatable-cell>\n          <datatable-cell name="stock" onclick="{handlers.copyText}" style="max-width: 20px;">{row.stock}</datatable-cell>\n\n        </yield>\n        <yield to="aggregation"></yield>\n      </catalog>\n    </div>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var self = this;

self.item = {};
self.mixin('change');
self.mixin('permissions');
self.allFilters = false;

self.startDate = '';
self.endDate = '';

self.cols = [{ name: '', value: '#' }, { name: 'article', value: 'Артикул' }, { name: 'nameBrand', value: 'Сидбанк' }, { name: 'name', value: 'Наименование' }, { name: 'expend', value: 'Продано' },
//{name: 'price', value: 'Цена'},
{ name: 'amount', value: 'Стоимость' }, { name: 'stock', value: 'Остаток' }];

self.Filters = function () {
    self.update();
    self.tags.catalog.reload();
};

self.handlers = {
    copyText: function copyText(elem) {
        copyToClipboard(elem.target);
    }
};

function copyToClipboard(elem) {

    var target = document.createElement("textarea");
    target.style.position = "absolute";
    target.style.left = "-9999px";
    target.style.top = "0";
    document.body.appendChild(target);
    target.value = elem.innerHTML.trim();

    target.focus();
    target.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
    } catch (err) {}
}

self.getAggregation = function (response, xhr) {
    self.item = response;
};
/*
self.reload = () => {
    self.loader = true
    self.update()

    API.request({
        object: 'Warehouse',
        method: 'Fetch',
        data: {},
        success(response) {
            self.item = response
        },
        complete() {
            self.loader = false
            self.update()
        }
    })
}
*/

self.one('updated', function () {
    self.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {

        self.selectedCategory = node.__selected__ ? node.id : undefined;
        var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
        if (items.length > 0) {
            var value = items.map(function (i) {
                return i.code;
            }).join(',');
            self.allFilters = [{ field: 'codeBrand', sign: 'IN', value: value }];
        } else {
            self.allFilters = false;
        }
        self.Filters();

        //self.update()
        //self.tags.catalog.reload()
    });
});

observable.on('warehouse-reload', function () {
    self.allFilters = [];
    self.update();
    self.tags.catalog.reload();
});

self.on('mount', function () {
    self.idManager = app.config.idUser;
    self.update();
});

/*
route('/orders/warehouse', () => {
    self.reload()
})

self.on('mount', () => {
    riot.route.exec()
})
*/
});


// WEBPACK FOOTER //
// ./pages/orders/sales-list.tag